<template>
    <div class="win">
        <div class="header">
            <div class="navItem">
                <i class="iconfont icon-shujudaochu"></i>
                <div :class="{title: true,  active: active === 0}" @click="handleChange(0)" v-bind:style="{ letterSpacing: language === 'en' ? '0px':''}">{{ $t('ems.tag.realData') }}</div>
                <div class="centerHr"></div>
                <div :class="{title: true,  active: active === 1}" @click="handleChange(1)" v-bind:style="{ letterSpacing: language === 'en' ? '0px':''}">{{ $t('ems.tag.dataExport') }}</div>
                <div class="centerHr"></div>
                <div :class="{title: true,  active: active === 2}" @click="handleChange(2)" v-bind:style="{ letterSpacing: language === 'en' ? '0px':''}">{{ $t('ems.tag.exportList') }}</div>
            </div>
        </div>
        <div class="content" v-loading="loading" element-loading-text="Loading" element-loading-spinner="el-icon-loading" element-loading-background="rgba(22, 22, 22, 1)">
            <div class="table_box" v-if="active === 1">
                <el-form @submit.native.prevent class="table_header tableSearchForm" :inline="true" size="small" label-width="140px" label-position="left">
                    <el-form-item :label="$t('ems.selectDevice')">
                        <el-cascader v-model="form.device" :options="deviceOptions"  style="width: 240px" @change="handleChangeDevice"></el-cascader>
                    </el-form-item>
                    <el-form-item :label="$t('ems.collectTime')" style="width: 620px">
                        <el-date-picker
                                v-model="form.time"
                                type="datetimerange"
                                :range-separator="$t('ems.history.to')"
                                :start-placeholder="$t('ems.history.StartDate')"
                                :end-placeholder="$t('ems.history.EndDate')"
                                style="width: 100%"
                                popper-class="dateDown"
                                :clearable="false"
                        >
                        </el-date-picker>
                    </el-form-item>

                    <div class="btn btn_active" @click="search"><i class="iconfont icon-sousuo"></i><span>{{ $t('ems.history.search') }}</span></div>
                    <div class="btn btn_active" @click="handleOpenColumnConfig" style="float:  right">
                        <i class="el-icon-s-operation"></i><span>{{ $t('ems.columnConfiguration') }}</span> 
                    </div>
                    <div class="btn btn_active"  style="float:  right">
                        <el-button type="text" icon="el-icon-download" :loading="downloadLoading" @click="downLoad" style="width: 100%; height: 100%;line-height: 30px; border-radius: 0px; color: rgb(10, 207, 230); font-size: 16px; padding: 0 10px">{{ $t('index.export') }}</el-button>
                    </div>
                </el-form>
                <el-table
                        ref="tableList"
                        :data="list"
                        style="width: 100%"
                        v-loading="listLoading"
                        border
                        size="small"
                        height="700"
                        class="BMSTable configList"
                >
<!--                    <el-table-column width="150" label="采集时间" prop="collectTime"></el-table-column>-->
<!--                    <el-table-column width="200" label="设备编号" prop="deviceNo"></el-table-column>-->
                    <template v-for="(item,index) in deviceField">
                        <el-table-column  fixed="left" :label="item.unit ? `${item.columnName}(${item.unit})` : item.columnName" :prop="item.columnField" v-if="index === 0" :key="index" width="180" ></el-table-column>
                        <el-table-column  :label="item.unit ? `${item.columnName}(${item.unit})` : item.columnName" :prop="item.columnField" v-if="index === 1" :key="index" width="180"></el-table-column>
                        <el-table-column  :label="item.unit ? `${item.columnName}(${item.unit})` : item.columnName" :prop="item.columnField" v-if="index > 1 &&  index < 52" :key="index" min-width="120"></el-table-column>
                    </template>
                </el-table>
                <div class="page">
                    <el-pagination
                            class="pagePagination"
                            background
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            layout="total, sizes, prev, pager, next,jumper"
                            :page-size="size"
                            :page-sizes="[ 20, 50, 100 ]"
                            :current-page.sync="page"
                            :total="total"
                            popper-class="selectDown"
                    ></el-pagination>
                </div>
            </div>
            <div class="table_box" v-else-if="active === 0">
                <el-form @submit.native.prevent class="table_header tableSearchForm" :inline="true" size="small" label-width="120px" label-position="left">
                    <el-form-item :label="$t('ems.selectDevice')">
                        <el-cascader v-model="form.device" :options="deviceOptions"  style="width: 240px" @change="handleChangeDevice"></el-cascader>
                    </el-form-item>
                    <el-form-item>
                        <el-input v-model="form.keyWord" :placeholder="$t('systemSetting.searchFilter')" style="width: 320px"></el-input>
                    </el-form-item>

                    <div class="btn btn_active"  style="float: right">
                        <el-button type="text" :loading="downloadLoading" @click="handleRealData" style="width: 100%; height: 100%;line-height: 30px; border-radius: 0px; color: rgb(10, 207, 230); font-size: 16px; padding: 0 10px">{{ $t('ems.pv.refresh') }}</el-button>
                    </div>

                    <div class="creatTime" style="float:  right" v-if="form.device[0] && form.device[1]">{{ $t('ems.power.DataUpdateTime') }}:<span>{{ realData.collectTime | nullFormat }}</span></div>
                </el-form>
                <div class="realDataItemBg">
                    <template v-for="(item, index) in realData.dataMap">
                        <div class="realDataItem"  :key="index"  v-if="index.includes(form.keyWord)">
                            <div class="value">{{item | nullFormat}}</div>
                            <div class="title">{{index}}</div>
                        </div>
                    </template>

                </div>
            </div>
            <div class="table_box" v-else>
                <el-form @submit.native.prevent class="table_header tableSearchForm" :inline="true" size="small" label-width="140px" label-position="left">
                    <el-form-item :label="$t('ems.tag.taskStatus')">
                        <el-select v-model="taskForm.taskStatus" :placeholder="$t('bms.PleaseSelectTip')"  popper-class="selectDown" @change="handTaskStatusChange">
                            <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <div class="btn btn_active"  style="float: right">
                        <el-button type="text" @click="getDownList" style="width: 100%; height: 100%;line-height: 30px; border-radius: 0px; color: rgb(10, 207, 230); font-size: 16px; padding: 0 10px">{{ $t('ems.pv.refresh') }}</el-button>
                    </div>
                </el-form>
                <el-table ref="taskList" :data="taskList" style="width: 100%" v-loading="listLoading" border size="small" height="700" class="BMSTable configList">
                    <el-table-column :label="$t('ems.alarm.DeviceName')" prop="deviceName"></el-table-column>
                    <el-table-column :label="$t('ems.tag.searchStart')"  prop="selectStartTime"></el-table-column>
                    <el-table-column :label="$t('ems.tag.searchEnd')"  prop="selectEndTime"></el-table-column>
                    <el-table-column  :label="$t('ems.tag.taskStatus')">
                        <template slot-scope="scope">
                            <span v-if="scope.row.taskStatus == 0" :style="{color: 'rgb(122,122,122)', lineHeight: '34px'}">{{ scope.row.taskStatus |  taskStatusF }}</span>
                            <span v-if="scope.row.taskStatus == 1" :style="{color: 'rgb(66,234,14)', lineHeight: '34px'}">{{ scope.row.taskStatus |  taskStatusF }}</span>
                            <span v-if="scope.row.taskStatus == 3" :style="{color: 'rgb(255, 192, 0)', lineHeight: '34px'}">{{ scope.row.taskStatus |  taskStatusF }}</span>
                            <span v-if="scope.row.taskStatus == 2" :style="{color: 'rgb(192, 0, 0)', lineHeight: '34px'}">{{ scope.row.taskStatus |  taskStatusF }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column :label="$t('ems.tag.tastStart')"  prop="createTime"></el-table-column>
                    <el-table-column :label="$t('ems.operate')" align="center">
                        <template slot-scope="scope">
                            <el-button @click.native.prevent="handleTaskDown(scope.row.url)" type="text" size="small" icon="el-icon-download"  v-if="scope.row.taskStatus === 1">{{ $t('systemSetting.clickDownLoad') }}</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="page">
                    <el-pagination
                            class="pagePagination"
                            background
                            @current-change="handleCurrentDownListChange"
                            layout="total, prev, pager, next,jumper"
                            :page-size="taskForm.size"
                            :current-page.sync="taskForm.page"
                            :total="taskForm.total"
                            popper-class="selectDown"
                    ></el-pagination>
                </div>
            </div>
            <div class="columnConfig" v-if="columnConfigVis">
                <columnConfig ref="columnConfig"></columnConfig>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import { GetDeviceByDeviceGroup, GetDeviceField, GetDeviceData, GetDeviceDataDownload, getRealDataByDevice, getTaskDownList } from "@/api/spms";
    import columnConfig from "./dataExport/columnConfig"
    import i18n from "@/lang";
    import moment from "moment";
    import { exportFile } from "@/utils/util";

    export default {
        name: "dataExportSys",
        components:{ columnConfig },
        data(){
            return {
                loading: false,
                active: 0,

                timer: '',
                form: {
                    device: ['', ''],
                    time: [moment().subtract(7, 'd').startOf('d'), moment()],
                    keyWord: '',
                },
                list: [],
                listLoading: false,
                size: 20,
                page: 1,
                total: 0,
                deviceOptions: [],
                deviceField: [],

                columnConfigVis: false,

                downloadLoading: false,

                realData: {
                    dataMap: {},
                },

                taskForm: {
                    size: 20,
                    total: 0,
                    page: 1,
                    taskStatus: '',
                },

                taskList: [],
                options: [
                    {value: '', label: i18n.t("ems.all")},
                    {value: 0, label: i18n.t("ems.tag.unStart")},
                    {value: 1, label: i18n.t("ems.tag.taskSuccess")},
                    {value: 2, label: i18n.t("ems.tag.taskErr")},
                    {value: 3, label: i18n.t("ems.tag.taskRunning")},
                ],

                baseUrl: imgBaseUrl,
                // baseUrl: " http://172.19.102.99:80/",

                taskFTimer: null,
            }
        },
        computed: {
            ...mapGetters(["language"]),
        },
        filters: {
            nullFormat(val){
                if(val === null || val === undefined || val === ''){
                    return "--"
                }else {
                    return val
                }
            },
            taskStatusF(val){
                const option =   [
                    {value: '', label: i18n.t("ems.all")},
                    {value: 0, label: i18n.t("ems.tag.unStart")},
                    {value: 1, label: i18n.t("ems.tag.taskSuccess")},
                    {value: 2, label: i18n.t("ems.tag.taskErr")},
                    {value: 3, label: i18n.t("ems.tag.taskRunning")},
                ];
                return (option.find(i => i.value === val) || {}).label;

            }

        },
        created(){
            this.initDeviceOption();
        },
        methods: {
            handleRealData(refresh){
                if(this.form.device[0] && this.form.device[1]){
                    if(refresh) this.loading = true;
                    getRealDataByDevice({deviceType: this.form.device[0], deviceId: this.form.device[1]}).then(res => {
                        this.loading = false;
                        if(res && res.data && res.data.data){
                            if(res.data.data.dataMap){
                                this.realData = res.data.data
                            }else{
                                res.data.data.dataMap = {};
                                this.realData = res.data.data;
                            }
                        }

                    }).catch(err => {
                        this.loading = false;
                        console.log(err);
                    });
                }
            },
            handleChange(value){
                this.active = value;
                this.loading = true;
                if(this.timer) clearInterval(this.timer);
                this.columnConfigVis = false;
                this.handleChangeDevice();

                setTimeout(() => {
                    this.loading = false;
                }, 500)
            },
            search(){
                this.page = 1;
                this.loadData();
            },
            handleOpenColumnConfig(){
                if(this.form.device[0] && this.form.device[1]){
                    if(this.columnConfigVis === true){
                        this.columnConfigVis = false;
                        setTimeout(() => {
                            this.handleChangeDevice();
                        }, 300);
                    }else{
                        this.columnConfigVis = true;
                    }
                }else{
                    this.$message.warning(i18n.t("ems.selectDevice"));
                }
            },

            downLoad(){
                if(this.form.time[0] && this.form.time[1] && this.form.device[0] && this.form.device[1]){
                    const params = {};
                    params.startCollectTime = moment(this.form.time[0]).format("YYYY-MM-DD HH:mm:ss");
                    params.endCollectTime = moment(this.form.time[1]).format("YYYY-MM-DD HH:mm:ss");
                    params.deviceType = this.form.device[0];
                    params.deviceId = this.form.device[1];

                    const num = moment(this.form.time[1]).diff(this.form.time[0], 'd');
                    if(params.deviceType == 'DCB' && num > 7){
                        this.$message.warning(i18n.t("ems.DeviceNotSupportDayTip"));
                        return false;
                    }
                    if(params.deviceType == 'CU' && num > 7){
                        this.$message.warning(i18n.t("ems.DeviceNotSupportDayTip"));
                        return false;
                    }
                    if( num > 31){
                        this.$message.warning(i18n.t("ems.DeviceNotSupportMonthTip")); 
                        return false;
                    }
                    this.downloadLoading = true;
                    GetDeviceDataDownload(params).then(res => {
                        this.downloadLoading = false;
                        this.$message.success(i18n.t("ems.tag.taskhas"));
                        setTimeout(() => {
                           this.handleChange(2);
                        }, 1000);
                        return false;
                        let fileName = res.headers['content-disposition'];
                        fileName = fileName.slice(fileName.indexOf('=') + 1, fileName.indexOf('.'));
                        exportFile(res.data, fileName,"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8;charset=UTF-8;");
                    }).catch(err => {
                        console.log(err);
                        this.downloadLoading = false;
                    });
                }else{
                    this.$message.warning(i18n.t("ems.PleaseSelectDownloadConditions")) 
                }
            },
            loadData(){
                this.listLoading = true;
                const params = {};
                params.size = this.size;
                params.current = this.page;
                params.startCollectTime = moment(this.form.time[0]).format("YYYY-MM-DD HH:mm:ss");
                params.endCollectTime = moment(this.form.time[1]).format("YYYY-MM-DD HH:mm:ss");
                params.deviceType = this.form.device[0];
                params.deviceId = this.form.device[1];
                delete params.time;
                GetDeviceData(params).then(res => {
                    this.listLoading = false;
                    this.total = res.data.data.total;
                    this.list = res.data.data.records.map(i => {
                        return Object.assign(i.dataMap, { collectTime: i.collectTime, deviceNo: i.deviceNo})
                    });
                }).catch(err => {
                    this.listLoading = false;
                    console.log(err);
                });
            },
            handleSizeChange(val) {
                this.page = 1;
                this.size = val;
                this.loadData();
            },
            handleCurrentChange(val) {
                this.page = val;
                this.loadData();
            },
            initDeviceOption(){
                // deviceType, deviceId
                GetDeviceByDeviceGroup().then(res => {
                    if(res && res.data && res.data.data){
                        const option = res.data.data.map(item => {
                            return {
                                value: item.deviceType,
                                label: item.deviceTypeName,
                                children: item.devices.map(i => {
                                    return {
                                        value: i.id,
                                        label: i.deviceName,
                                    }
                                })
                            }
                        });
                        this.deviceOptions = option;
                    }
                });
            },

            handleChangeDevice() {
                if (this.timer) {
                    clearInterval(this.timer);
                    this.timer = null;
                }
                if(this.taskFTimer){
                    clearInterval(this.taskFTimer);
                    this.taskFTimer = null;
                }
                if(this.active === 1){
                    this.loading = true;
                    if(this.form.device[0] && this.form.device[1]){
                        GetDeviceField({deviceType: this.form.device[0], deviceId: this.form.device[1]}).then(res => {
                            if (res && res.data && res.data.data) {
                                this.deviceField = res.data.data || [];
                                setTimeout(() => {
                                    this.$refs.tableList.doLayout();
                                    this.page = 1;
                                    this.loadData();
                                    if(this.$refs['columnConfig']){
                                        this.$refs['columnConfig'].initData();
                                    }
                                    this.loading = false;
                                }, 500)
                            }
                        });
                    }
                }else if(this.active === 0){
                    this.handleRealData(true);
                    this.timer = setInterval(() => {
                        this.handleRealData(false);
                    }, 3000)
                }else{
                    this.taskForm.taskStatus = "";
                    this.taskForm.page = 1;
                    this.getDownList();
                    this.taskFTimer = setInterval(() => {
                        this.getDownList();
                    }, 2000)
                }
            },
            handleCurrentDownListChange(val){
                this.taskForm.page = val;
                this.getDownList();
            },
            getDownList(){
                getTaskDownList({ current: this.taskForm.page, size: this.taskForm.size, taskStatus: this.taskForm.taskStatus }).then(res => {
                    this.listLoading = false;
                    // 0 未执行 1 执行成功 2 执行失败 3执行中
                    if(res && res.data && res.data.data){
                        this.taskList = res.data.data.records;
                        this.taskForm.total = res.data.data.total;
                    }
                })
            },

            handleTaskDown(url){
                window.open(this.baseUrl + url, '_self');
            },

            handTaskStatusChange(){
                this.getDownList();
            }
        },
        destroyed() {
            if(this.timer) clearInterval(this.timer);
            if(this.taskFTimer) clearInterval(this.taskFTimer);

        }
    }
</script>

<style scoped lang="scss">
    @import "../../../../styles/site";
    .win{
        width: 100%;
        height: 100%;
        .header{
            height: 52px;
            background-color: var(--nav_inner);
            position: relative;
            .navItem{
                height: 100%;
                display: flex;
                align-items: center;
                transition: all 0.3s linear;
                i{
                    color: $font_bright_blue_title;
                    font-size: 22px;
                    margin: 3px 20px 0;
                }
                .title{
                    letter-spacing: 3px;
                    font-size: 22px;
                    color: $_166_166_166;
                    cursor: pointer;
                }
                .centerHr{
                    background: $_191_191_191;
                    height: 35px;
                    width: 1px;
                    margin-right: 10px;
                    margin-left: 10px;
                }
                .active{
                    color: $font_bright_blue_title;
                }
                .desc{
                    margin-left: 24px;
                    font-size: 14px;
                    color: $_128_128_128;
                }
            }
        }
        .content{
            height: calc(100% -  52px);
            padding: 0 30px;
            overflow: hidden;
            position: relative;
            .table_box{
                width: 100%;
                .table_header{
                    margin-top: 20px;
                    height: 30px;
                    margin-bottom: 20px;
                }
                .page{
                    margin-top: 20px;
                }
                .realDataItemBg{
                    height: 740px; background: var(--nav_inner); overflow-y: auto
                }

                .realDataItem{
                    width: 224px;
                    height: 132px;
                    background:  var(--table_header);
                    float: left;
                    margin-top: 12px;
                    margin-left: 20px;
                    position: relative;
                    .title{
                        position: absolute;
                        top: 0;
                        left: 0;
                        right: 0;
                        height: 50px;
                        // line-height: 34px;
                        padding-left: 20px;
                        background-color: var(--dataItem) ;
                        color: $_166_166_166;
                        display: flex;
                        align-items: center;
                    }


                    .value{
                        height: calc(100% - 50px);
                        margin-top: 50px;
                        margin-left: 20px;
                        font-size: 24px;
                        display: flex;
                        align-items: center;
                        color: $font_bright_blue_title;
                    }

                }

                .creatTime{
                    margin-top: 4px;
                    font-size: 18px;
                    color: $_191_191_191;
                    margin-right: 40px;
                    width: 340px;
                    span{
                        padding-left: 20px;
                        color: $font_bright_blue_title;
                    }
                }
            }
            .columnConfig{
                position: absolute;
                left: 0;
                top: 70px;
                width: 100%;
                height: 768px;
                z-index: 1999;
            }
        }
    }
</style>
<style lang="scss">
    .configList{
        .el-table__body-wrapper::-webkit-scrollbar {
            width: 10px;
            height: 12px !important;
        }
    }
</style>